import { useCallback, useContext, useMemo } from 'react';

import { PermissionsContext } from '@/app/components/Provider/PermissionsProvider';
import { MenuInfo } from '@/constants/Menu';

export const usePermissions = () => {
  const { permission } = useContext(PermissionsContext);

  const getPermission = useCallback(
    (conditions: PermissionKey[]) => {
      return Object.keys(permission).some((per) => conditions.includes(per as PermissionKey));
    },
    [permission]
  );

  const MenuSidebar = useMemo(() => {
    return Object.values(MenuInfo)
      .filter((menu) => {
        if (!menu.sub) {
          return getPermission(menu.permission ?? []);
        }
        if (menu.path === '/setting') return true;
        const permissions = Object.values(menu.sub).reduce(
          (prev, cur) => [...prev, ...(cur.permission ?? [])],
          [] as PermissionKey[]
        );
        return getPermission(permissions);
      })
      .map((menu) => ({
        ...menu,
        sub: menu.sub
          ? Object.values(menu.sub).filter((sub) => {
              if (sub.path === '/setting/master-data') return true;
              return getPermission(sub.permission ?? []);
            })
          : null,
      }));
  }, [getPermission]);

  return useMemo(
    () => ({
      getPermission,
      MenuSidebar,
    }),
    [MenuSidebar, getPermission]
  );
};
